import React, { useState } from "react";
import "../CSS/Contact.css";
import { useToast } from "../../Common/Components/ToastProvider";
import LoadingSpinner from "../../Common/Components/LoadingSpinner";
import ThankYouPopup from "../Components/ThankYouPopup";
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiCheck,
  FiClock,
  FiLayers,
  FiUser,
} from "react-icons/fi";

const Contact = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    phone: "",
    interestedIn: "",
    projectdetails: "",
  });
  const { showToast } = useToast();

  const handleChange = (e) => {
    setContactData({
      ...contactData,
      [e.target.name]: e.target.value,
    });
  };

  const handleContactSubmission = async (e) => {
    e.preventDefault();

    if (
      !contactData.name ||
      !contactData.email ||
      !contactData.interestedIn ||
      !contactData.projectdetails
    ) {
      showToast("All fields are required ( except phone )", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: contactData.name,
          email: contactData.email,
          phone: contactData.phone,
          interestedIn: contactData.interestedIn,
          projectdetails: contactData.projectdetails,
        }),
      });

      const data = await response.json();
      if (data.status === true) {
        showToast(data.message || "Submited successfully...", "success");
        setLoading(false);
        setShowPopup(true);
        setContactData({
          name: "",
          email: "",
          phone: "",
          interestedIn: "",
          projectdetails: "",
        });
      } else {
        showToast(
          data.message || "Error occured while submitting, please retry!",
          "error"
        );
      }
    } catch (error) {
      console.log("Error occured while submitting contact form: ", error);
      showToast("Network error, please try after some time", "error");
    }
  };
  const benefitsData = [
    {
      id: 1,
      icon: <FiCheck />,
      title: "24-Hour Response",
      description:
        "Get a detailed project quote and consultation within 24 hours of reaching out.",
    },
    {
      id: 2,
      icon: <FiClock />,
      title: "Transparent Process",
      description:
        "Clear timelines, regular updates, and honest communication throughout the project.",
    },
    {
      id: 3,
      icon: <FiLayers />,
      title: "Ongoing Support",
      description:
        "Continued maintenance, updates, and support long after your project launches.",
    },
  ];

  const faqData = [
    {
      id: 1,
      question: "How long does a typical project take?",
      answer:
        "Project timelines vary based on scope and complexity. A basic website typically takes 2-4 weeks, while more complex applications can take 8-16 weeks. We'll provide a detailed timeline during our initial consultation based on your specific requirements.",
    },
    {
      id: 2,
      question: "What is your pricing structure?",
      answer:
        "We offer flexible pricing based on project scope. After understanding your requirements, we provide a detailed proposal with transparent pricing. We accept milestone-based payments and offer various engagement models including fixed-price projects and monthly retainers.",
    },
    {
      id: 3,
      question: "Do you provide ongoing support after launch?",
      answer:
        "Yes! We offer comprehensive post-launch support including bug fixes, updates, performance monitoring, and feature enhancements. We also provide monthly maintenance packages to ensure your solution stays current and secure.",
    },
    {
      id: 4,
      question: "Can you work with our existing tech stack?",
      answer:
        "Absolutely. Our team is experienced with a wide range of technologies and can integrate with your existing systems. We'll assess your current infrastructure during discovery and recommend the best approach for your project.",
    },
    {
      id: 5,
      question: "What industries do you specialize in?",
      answer:
        "We work across multiple industries including e-commerce, SaaS, healthcare, education, real estate, and logistics. Our diverse experience allows us to bring best practices from different sectors to solve your unique challenges.",
    },
  ];
  return (
    <>
      <title>Contact Us | Get Free Consultation & Project Quote - Syncnode</title>
      <meta name="description" content="Get in touch with Syncnode for web development, Android apps, custom software, automation, and digital marketing. 24-hour response time, transparent process. Contact us at +91 7876666787 or info@syncnode.in" />
      <meta name="keywords" content="contact syncnode, web development consultation, android app development, project quote, hire developers, IT services, technology consulting, Hisar Haryana" />
      <link rel="canonical" href="https://www.syncnode.in/contact" />
      <meta property="og:title" content="Contact Us | Get Free Consultation & Project Quote - Syncnode" />
      <meta property="og:description" content="Ready to transform your business? Contact Syncnode for free consultation. 24-hour response, transparent pricing, expert IT services team." />
      <meta property="og:url" content="https://www.syncnode.in/contact" />
      <meta property="og:type" content="website" />
      {loading && <LoadingSpinner />}
      <div className="contact_wrapper">
        <div className="container">
          <div className="contact_banner">
            <h1>
              Let's Build Something <br />{" "}
              <span className="decorated_text">Extraordinary</span>
            </h1>
            <p className="intro_text">
              Ready to transform your business? Get in touch with our team and
              receive a free consultation and project quote.
            </p>
          </div>

          <div className="contact_details_wrapper">
            <div className="form_wrapper">
              <form onSubmit={handleContactSubmission}>
                <h2>Send Us a Message</h2>
                <p>Fill out the form and we'll get back to you</p>
                <div className="form_row">
                  <div className="form_group">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={contactData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form_group">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={contactData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form_row">
                  <div className="form_group">
                    <label>Phone Number (Optional)</label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      value={contactData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form_group">
                    <label>Service Interested In</label>
                    <select
                      name="interestedIn"
                      id="interestedIn"
                      value={contactData.interestedIn}
                      onChange={handleChange}
                    >
                      <option value="">Select a Service</option>
                      <option value="web">Web Development</option>
                      <option value="app">App Development</option>
                      <option value="automation">Automation</option>
                      <option value="marketing">Marketing</option>
                      <option value="ecommerce">E-commerce</option>
                      <option value="consulting">Tech Consultancy</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="form_group">
                  <label>Project Details</label>
                  <textarea
                    name="projectdetails"
                    id="projectdetails"
                    value={contactData.projectdetails}
                    onChange={handleChange}
                    placeholder="Tell us about your project, goals, and timeline..."
                    rows={5}
                  ></textarea>
                </div>
                <button className="primary_button btn full_width" type="submit">
                  {loading ? "Submitting..." : "Submit Response"}
                </button>
              </form>
            </div>

            <div className="details_wrapper">
              <h4>Get In Touch</h4>
              <p className="detail_intro">
                Whether you have a project in mind or just want to explore
                possibilities, we're here to help you succeed.
              </p>

              <div className="info_wrapper">
                <div className="item">
                  <div className="icon_container">
                    <FiUser className="icon" />
                  </div>
                  <div className="content">
                    <h4>Contact Person</h4>
                    <p>Ankit</p>
                  </div>
                </div>
                <div className="item">
                  <div className="icon_container">
                    <FiMail className="icon" />
                  </div>
                  <div className="content">
                    <h4>Email Us</h4>
                    <p>info@syncnode.in</p>
                  </div>
                </div>
                <div className="item">
                  <div className="icon_container">
                    <FiPhone className="icon" />
                  </div>
                  <div className="content">
                    <h4>Call Us</h4>
                    <p>+91 7876666787</p>
                  </div>
                </div>
                <div className="item">
                  <div className="icon_container">
                    <FiMapPin className="icon" />
                  </div>
                  <div className="content">
                    <h4>Visit Us</h4>
                    <p>Hisar, Haryana</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="reason_wrapper">
            <p className="sub_title">Why Choose Us</p>
            <h1 className="title">What You Get</h1>
            <p className="section_intro">
              Working with Syncnode means partnering with a team that's
              committed to your success.
            </p>

            <div className="reason_row">
              {benefitsData.map((benefit) => (
                <div className="reason_item" key={benefit.id}>
                  <div className="reason_icon">{benefit.icon}</div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="questionanswers_wrapper">
            <p className="sub_title">Faq</p>
            <h1 className="title">Common Questions</h1>
            <p className="section_intro">
              Everything you need to know about working with us.
            </p>

            <div className="row">
              {faqData.map((faq) => (
                <div className="item" key={faq.id}>
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        {showPopup && (
          <>
            <ThankYouPopup
              message="Your query has been submitted successfully! We will get back to you soon. Stay tuned!"
              onClose={() => setShowPopup(false)}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Contact;
